import { useState } from "react";

/**
 * A tile's picture: its lighter thumbnail first, the full picture when there is none or it fails
 * to load (a thumbnail can lag its file: a global actor's is made by the first sweep after a
 * deploy; issue 828, item 12). `onError` falls back from the thumbnail, and from the full
 * picture calls `onLost` (a list reads its signed URLs again).
 */
export function useThumbFirst(
  thumb: string | null | undefined,
  full: string,
  onLost?: () => void,
): { src: string; onError: () => void } {
  const [failed, setFailed] = useState<string | null>(null);
  const lighter = thumb !== null && thumb !== undefined && failed !== thumb ? thumb : null;
  return {
    src: lighter ?? full,
    onError: () => {
      if (lighter !== null) setFailed(lighter);
      else onLost?.();
    },
  };
}
